import React, { useState, useEffect } from 'react';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import { useAuthStore } from '../../../stores/authStore';

type AuthMode = 'login' | 'register' | 'forgot';

interface AuthPageProps {
  initialMode?: AuthMode;
  /** 从首页进来时，提供「返回首页」 */
  onBack?: () => void;
}

export const AuthPage: React.FC<AuthPageProps> = ({ initialMode = 'login', onBack }) => {
  const [mode, setMode] = useState<AuthMode>(initialMode);
  const { clearError } = useAuthStore();

  // 清除错误当切换模式时
  useEffect(() => {
    clearError();
  }, [mode, clearError]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-75">
      {onBack && (
        <button type="button" onClick={onBack} className="absolute left-5 top-5 text-sm text-gray-500 hover:text-gray-800">
          ← 返回首页
        </button>
      )}
      <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/mengdong-mark.webp" alt="蒙懂" className="mx-auto mb-3 h-10 w-auto" />
          <h1 className="text-xl font-semibold text-gray-700">蒙懂看板</h1>
          <p className="mt-1 text-sm text-gray-500">人和 agent 共用一块看板</p>
        </div>
        
        {/* Tab 切换 */}
        {mode !== 'forgot' && <div className="flex mb-6 bg-gray-100 rounded-lg p-1">
          <button
            onClick={() => setMode('login')}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-all duration-200 ${
              mode === 'login'
                ? 'bg-white text-blue-600 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            登录
          </button>
          <button
            onClick={() => setMode('register')}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-all duration-200 ${
              mode === 'register'
                ? 'bg-white text-blue-600 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            注册
          </button>
        </div>}
        
        {/* 表单内容 */}
        <div className="transition-all duration-300">
          {mode === 'login' && (
            <>
              <LoginForm />
              <button type="button" onClick={() => setMode('forgot')} className="mt-4 w-full text-center text-sm text-gray-500 hover:text-gray-800">忘记密码？</button>
            </>
          )}
          {mode === 'register' && <RegisterForm />}
          {mode === 'forgot' && <ForgotPasswordForm onDone={() => setMode('login')} />}
        </div>
      </div>
      
      {/* 版权声明 - 固定在页面底部 */}
      <div className="absolute bottom-0 left-0 right-0 text-center pb-6">
        <p className="text-sm text-gray-500 mb-1">
          © 2026 蒙懂AI
        </p>
        <p className="text-xs text-gray-400">
          <a
            href="https://mengdong.video/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-600 transition-colors"
          >
            用户协议
          </a>
          <span className="mx-2">·</span>
          <a
            href="https://mengdong.video/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-600 transition-colors"
          >
            隐私政策
          </a>
        </p>
      </div>
    </div>
  );
};